import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
`

export const ModalCard = styled.div`
  width: 415px;
  max-width: 415px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  padding: 15px 25px;
  background: ${(props) => props.theme.colors.card.background};
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.12);
  outline: none;
`

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
`

export const ModalTitle = styled.h3`
  margin: 0;
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontPlusJakartaSans};
  font-size: 20px;
  font-weight: 700;
  line-height: 1.1;
`

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 18px;
`

export const ModalMessage = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontNunito};
  font-size: 15px;
  font-weight: 400;
`

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 6px;
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontNunito};
  font-size: 13px;
  font-weight: 400;
`

export const InputField = styled.input`
  width: 100%;
  height: 33px;
  border: 1px solid ${(props) => props.theme.colors.border.primary};
  border-radius: 12px;
  padding: 10px 14px;
  background: ${(props) => props.theme.colors.card.background};
  color: ${(props) => props.theme.colors.text.primary};
  font-family: ${(props) => props.theme.typography.fontNunitoSans};
  font-size: 15px;
  font-weight: 400;
  outline: none;

  ::placeholder {
    color: ${(props) => props.theme.colors.text.paragraph};
  }
`
